import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChefHat, X, ArrowRight, Heart } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ProjectMini() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const lastShown = localStorage.getItem('project_mini_last_shown');
    const now = new Date().getTime();
    const fourHours = 4 * 60 * 60 * 1000; // Popping up more frequently for urgency

    if (!lastShown || now - lastShown > fourHours) {
      const timer = setTimeout(() => setIsVisible(true), 5000); // 5 seconds delay
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('project_mini_last_shown', new Date().getTime().toString());
  };

  const handleNavigation = () => {
    if (location.pathname !== '/') {
      navigate('/#daily-feeding-section');
    } else {
      const element = document.getElementById('daily-feeding-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    handleClose();
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <div className="fixed bottom-6 right-6 z-[999] w-[calc(100%-3rem)] max-w-sm md:bottom-10 md:right-10">
          <motion.div 
            initial={{ opacity: 0, y: 50, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="bg-[#E27D60] rounded-[2rem] p-6 shadow-2xl border-b-4 border-[#C36A51] relative overflow-hidden" // Warm Terracotta background
          >
            {/* Background Accent */}
            <div className="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-2xl" />

            <button onClick={handleClose} className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors z-10">
              <X size={20} />
            </button>

            <div className="p-2 relative z-10">
              <div className="flex items-center gap-2 text-white/80 mb-4">
                <ChefHat size={18} />
                <span className="text-[10px] font-black uppercase tracking-[0.2em]">Urgent Daily Need</span>
              </div>

              <h3 className="text-white text-xl font-black uppercase italic leading-tight mb-3">
                Support the  <br />Kids' Feeding project
              </h3>
              
              <p className="text-white/90 text-sm mb-6 leading-relaxed italic">
                For our children, hunger is a daily shadow. Just **$50** guarantees food for every child, for an entire day.
              </p>

              <div className="flex items-center gap-4 bg-white/10 backdrop-blur-sm p-4 rounded-2xl border border-white/20 mb-6">
                <Heart className="text-white shrink-0" size={24} fill="white" />
                <div>
                  <p className="text-white font-black text-xl">$50</p>
                  <p className="text-[10px] text-white/70 uppercase font-bold">Feeds them all today</p>
                </div>
              </div>

              <button 
                onClick={handleNavigation}
                className="w-full bg-white hover:bg-[#E27D60] text-[#E27D60] hover:text-white py-4 rounded-2xl font-black text-[11px] uppercase tracking-widest transition-all duration-300 flex items-center justify-center gap-2 shadow-lg"
              >
                GIVE HOPE TODAY <ArrowRight size={16} />
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}